export const BOT_PROFILES = Object.freeze({
    easy: {
        reactionSeconds: 0.45,
        aimNoiseDeg: 4,
        decisionTicksMin: 8,
        decisionTicksMax: 14,
        lead: false,
        useCover: false,
        abilityChance: 0.15,
        ultChance: 0.3,
        fireAngleDeg: 6,
        heatCeiling: 0.92,
        aimLag: 0.12,
        strafeFlipChance: 0.2,
    },
    normal: {
        reactionSeconds: 0.25,
        aimNoiseDeg: 2,
        decisionTicksMin: 5,
        decisionTicksMax: 9,
        lead: true,
        useCover: true,
        abilityChance: 0.4,
        ultChance: 0.6,
        fireAngleDeg: 4,
        heatCeiling: 0.85,
        aimLag: 0.2,
        strafeFlipChance: 0.25,
    },
    hard: {
        reactionSeconds: 0.12,
        aimNoiseDeg: 0.8,
        decisionTicksMin: 3,
        decisionTicksMax: 6,
        lead: true,
        useCover: true,
        abilityChance: 0.7,
        ultChance: 0.9,
        fireAngleDeg: 2.5,
        heatCeiling: 0.8,
        aimLag: 0.35,
        strafeFlipChance: 0.3,
    },
});
//# sourceMappingURL=difficulty.js.map